import React from "react";
import * as styles from "./CustomPromoErrorModal.module.scss";
import Modal from "../../Modal/Modal";
import {
  Button,
  ButtonsContainer,
  Icon,
  ModalBody
} from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";
import { useOverridePhoneNumberInABTest } from "src/inbound-ab-test-experiment/phone";
import { LanguageCode } from "src/utils/localization/languages/types";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  languageCode: LanguageCode;
};

const CustomPromoErrorModal: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  languageCode
}) => {
  const handleExploreOffersClick = () => {
    const urls: Record<LanguageCode, string> = {
      en: "/best-luxury-cruise-deals.html",
      es: "/es/ofertas-exclusivas.html",
      "pt-br": "/pt-br/ofertas-exclusivas.html",
      de: "/de/exklusive-angebote.html",
      fr: "/fr/offres-exclusives.html"
    };

    const url = urls[languageCode] || urls.en;

    onRequestClose();
    window.location.href = url;
  };

  const handleFindYourCruiseClick = () => {
    const urls: Record<LanguageCode, string> = {
      en: "/find-a-cruise.html",
      es: "/es/crucero.html",
      "pt-br": "/pt-br/cruzeiro.html",
      de: "/de/kreuzfahrt.html",
      fr: "/fr/croisiere.html"
    };

    const url = urls[languageCode] || urls.en;

    onRequestClose();
    window.location.href = url;
  };

  return (
    <Modal
      modal={{ isOpen: isOpen, onRequestClose: undefined }}
      size="small"
      dataContentName="custom_promo_error_modal"
    >
      <ModalBody variant="full" className={styles.modalBodyWrapper}>
        <div className={styles.errorIconContainer}>
          <React.Fragment>
            <Icon name="alert" size="2x" padding="inline" />{" "}
            <Trans>Offer not available</Trans>
          </React.Fragment>
        </div>
        <div className={styles.modalContent}>
          <div className={styles.title}>
            <Trans>We couldn't apply your promotion</Trans>
          </div>
          <div className={styles.body}>
            <Trans>
              We’re sorry - there was a problem retrieving your offer. The
              promotion may have expired, or there might be a technical issue
              with the link you used. Please double-check the expiration date in
              your email. If everything looks correct, our team will be happy to
              assist you further. You’ll find our contact details just below.
            </Trans>
          </div>
          <div className={styles.contacts}>
            <span className={styles.phoneNumber}>
              {useOverridePhoneNumberInABTest()}
            </span>
          </div>
          <div className={styles.buttonsContainer}>
            <ButtonsContainer mobileFullSize>
              <Button
                renderAs="button"
                dataContentPiece="customPromoErrorModal"
                variant="primary"
                onClick={handleExploreOffersClick}
              >
                <Trans>Explore other offers</Trans>
              </Button>
              <Button
                renderAs="button"
                dataContentPiece="customPromoErrorModal"
                variant="secondary"
                onClick={handleFindYourCruiseClick}
              >
                <Trans>Find your cruise</Trans>
              </Button>
            </ButtonsContainer>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CustomPromoErrorModal;
